export const manifest = {
  screens: {
    scr_lz1nto: { name: "Home", route: "/" },
  },
}
